var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Tick = function Tick() {
    return (_jsxs("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", version: "1.1", id: "Capa_1", x: "0px", y: "0px", width: "512px", height: "512px", viewBox: "0 0 448.8 448.8", xmlSpace: "preserve", className: "tick-icon-svg" }, { children: [_jsx("g", { children: _jsx("g", __assign({ id: "check" }, { children: _jsx("polygon", { points: "142.8,323.85 35.7,216.75 0,252.45 142.8,395.25 448.8,89.25 413.1,53.55   ", fill: "#27CE0A" }) })) }), _jsx("g", {}), _jsx("g", {}), _jsx("g", {}), _jsx("g", {}), _jsx("g", {}), _jsx("g", {}), _jsx("g", {}), _jsx("g", {}), _jsx("g", {}), _jsx("g", {}), _jsx("g", {}), _jsx("g", {}), _jsx("g", {}), _jsx("g", {}), _jsx("g", {})] })));
};
export default Tick;
